/**
 * Point-in-time connectivity check, used to enforce offline read-only mode.
 * See docs/superpowers/specs/2026-09-11-offline-read-only-design.md.
 *
 * Deliberately NOT useOnlineStatus(). That composable is the reactive one the
 * offline bar and the disabled controls render from, and it registers
 * onMounted/onUnmounted hooks, so it only works inside a component. A Pinia
 * action needs a plain answer to "can this write reach the server right now",
 * asked at the moment of the call.
 *
 * Both read the same browser signal, so they cannot disagree.
 *
 * FAILS OPEN, never closed. Only an explicit `onLine === false` counts as
 * offline: no navigator (SSR, or a runtime without one) answers "not offline".
 * The wrong default here would silently disable every write in the app in an
 * environment nobody anticipated, which is far worse than briefly allowing a
 * write that cannot be delivered.
 *
 * Known limitation, documented in the spec: navigator.onLine reports network
 * attachment, not reachability. A captive portal or one bar of signal both
 * report online. This closes the case where the browser KNOWS it is offline,
 * which is the common one at a festival.
 */
export function isOffline(nav: { onLine?: boolean } | undefined = globalThis.navigator): boolean {
    return nav?.onLine === false;
}
